import React, { useState, useEffect } from 'react';
import { AlertTriangle, X } from 'lucide-react';

export default function DisclaimerFooter() {
  const [isVisible, setIsVisible] = useState(true);
  const version = import.meta.env.PACKAGE_VERSION || '1.7.2';
  const isBeta = version.includes('beta');

  useEffect(() => {
    // Check local storage for dismissed state
    const isDismissed = localStorage.getItem('disclaimerDismissed');
    if (isDismissed === 'true') {
      setIsVisible(false);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('disclaimerDismissed', 'true');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white/80 backdrop-blur-sm border-t border-gray-200 p-4">
      <div className="max-w-3xl mx-auto text-center space-y-2 relative">
        <button
          onClick={handleDismiss}
          className="absolute right-0 top-0 p-1 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-100"
          aria-label="Dismiss disclaimer"
        >
          <X className="h-5 w-5" />
        </button>
        
        <h3 className="text-sm font-medium text-gray-700">
          Version {version}
          {isBeta && (
            <span className="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
              Beta
            </span>
          )}
        </h3>
        <div className="text-sm text-gray-600">
          <p className="flex items-center justify-center gap-2">
            <AlertTriangle className="h-4 w-4 text-orange-500" />
            <span>
              These WAF rules are not compatible with Cloudflare Enterprise
              (Kinsta, Rocket.net, and optional for Cloudways)
            </span>
          </p>
          <p className="mt-1 text-xs text-gray-500">
            Use at your own risk. We are not responsible for any damages or issues that may arise from using these WAF rules.
          </p>
          <p className="mt-1 text-xs text-gray-500">
            Cloudflare, the Cloudflare logo, Cloudflare Workers, and other related names and wordmarks are trademarks and/or registered trademarks of Cloudflare, Inc.
          </p>
        </div>
      </div>
    </div>
  );
}